import { updateListingLikes } from '../api';

/**
 * Update the likes count for a listing via the server API
 * 
 * @param {string} listingId - ID of the listing to update
 * @param {boolean} increment - Whether to increment (true) or decrement (false) the count
 * @returns {Promise<Object>} - Promise that resolves with the updated likes count
 */
export const updateListingLikesCount = (listingId, increment) => {
  return updateListingLikes({ listingId, increment });
}; 